import history from '@/api/history';
 
export default{
    history,
}